import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import AccionesList from "../../comun/components/accionesList";
import { ListaMINVU } from "../../comun/components/modalListadoMinvu";
import Acciones from "../components/acciones";
import { Archivominvu } from "../models/cobroSeguros";

export function useColumns(renderizar: () => void): { COLUMNS: columns<Archivominvu>[] } {

    const COLUMNS: columns<Archivominvu>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <Acciones
                    data={row}
                    renderizar={renderizar}
                    
                />
            ,
            sortable: false,
            wrap: true,
            export: true,
        },
        {
            name: 'ID archivo',
            selector: (row) =>
                row.id,
            sortable: true,
            sortField: 'id',
            wrap: true,
            export: true
        },
        {
            name: 'Subsidio',
            selector: (row) => row.tiposubsidioCodigo,
            sortable: true,
            sortField: 'tiposubsidioCodigo',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Fecha generación',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechageneracion?.toString() ?? ''),
            sortable: true,
            sortField: 'fechageneracion',
            wrap: true,
            export: true,
        },
        {
            name: 'Fecha cobro',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechacobro?.toString() ?? ''),
            sortable: true,
            sortField: 'fechacobro',
            wrap: true,
            export: true,
        },        
    ]

    return { COLUMNS };
}